import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";

const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

export const fetchCancelReasons = async () => {
  const token = getAuthToken();

  if (!token) {
    console.error("Authentication token missing.");
    return { data: null, error: "Authentication required" };
  }

  try {
    console.log("Fetching cancellation reasons...");
    const response = await axios.get(`${API_ENDPOINTS.cancelReason}`, {
      headers: { Authorization: token },
    });

    console.log("Full API Response:", response.data.data);

    if (response.status === 200 && response.data?.success) {
      return { data: response.data.data, error: null };
    } else {
      console.error("Unexpected Response Structure:", response.data);
      return { data: null, error: "Unexpected response format" };
    }
  } catch (error) {
    console.error("Error fetching cancellation reasons:", error.response?.data || error.message);
    return { data: null, error: "Failed to load cancellation reasons" };
  }
};

export const submitCancelReason = async (reasonArray) => {
  const token = getAuthToken();

  if (!token) {
      console.error("Authentication token missing.");
      return { data: null, error: "Authentication required" };
  }

  try {
      console.log("Submitting cancellation reason:", reasonArray); // Debugging

      const response = await axios.post(
          `${API_ENDPOINTS.cancelReason}`,
          { reason: reasonArray }, // Make sure it's an array
          { headers: { Authorization: token } }
      );

      console.log("Full API Response:", response);

      if (response.status === 201 && response.data?.success) {
          console.log("Cancellation reason submitted successfully!");
          return { data: response.data, error: null };
      } else {
          console.error("Failed to submit reason:", response.data?.message || "Unknown error");
          return { data: null, error: response.data?.message || "Failed to submit reason" };
      }
  } catch (error) {
      console.error("Error submitting cancellation reason:", error.response?.data || error.message);
      return { data: null, error: error.response?.data?.message || "Failed to submit reason" };
  }
};

